<template>
  <v-dialog
    v-model="dialog"
    max-width="800px"
    persistent
  >
    <v-btn
      slot="activator"
      icon
    >
      <v-icon color="secondary">edit</v-icon>
    </v-btn>
    <v-card>
      <v-card-title>
        <span class="headline">Eintrag bearbeiten</span>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-form
            ref="form"
            v-model="valid"
            lazy-validation
          >
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field
                  type="text"
                  v-model="localAd.title"
                  label="Titel"
                  :rules="[rules.required]"
                >
                </v-text-field>
              </v-flex>
              <v-flex xs12>
                <image-uploader
                  ref="image"
                  v-model="localAd.imageUrl"
                  label="Bild"
                />
              </v-flex>
              <v-flex
                xs12
                sm6
              >
                <date-picker
                  v-model="localAd.validFrom"
                  label="Sichtbar von"
                  :rules="[rules.required]"
                />
              </v-flex>
              <v-flex
                xs12
                sm6
              >
                <date-picker
                  v-model="localAd.validTo"
                  label="Sichtbar bis"
                  :rules="[rules.required]"
                />
              </v-flex>
            </v-layout>
          </v-form>
        </v-container>
        <small>*Pflichtfelder</small>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn
          :loading="loading"
          color="secondary"
          flat
          @click.native="save()"
        >Speichern
        </v-btn>
        <v-btn
          color="error"
          flat
          @click.native="dialog = false; localAd = {}"
        >Abbrechen
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import {mapActions, mapGetters} from 'vuex';
  import ImageUploader from '../../files/_components/imageUploader';
  import DatePicker from '../../../components/date-picker';

  export default {
    name: 'DlgAdEdit',
    components: {DatePicker, ImageUploader},
    props: {
      ad: {
        type: Object,
        default: null,
      },
    },
    data() {
      return {
        dialog: false,
        valid: true,
        localAd: {},
        loading: false,
      };
    },
    watch: {
      dialog() {
        this.localAd = JSON.parse(JSON.stringify(this.ad));
      },
    },
    computed: {
      ...mapGetters({
        rules: 'rules/all',
      }),
    },
    methods: {
      ...mapActions({
        adUpdate: 'ads/update',
        adGetAll: 'ads/read',
      }),
      save() {
        if (this.$refs.form.validate()) {
          this.loading = true;

          this.$refs.image.doUpload()
            .then((filename) => {
              this.localAd.imageUrl = filename;
              return this.adUpdate(this.localAd);
            })
            .then((success) => {
              this.loading = false;
              if (success) {
                this.localAd = {};
                this.adGetAll();
                this.dialog = false;
              }
            });
        }
      },
    },
  };
</script>

<style scoped>

</style>
